import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-error"
}

import type { PropType } from 'vue';
import { useSortable } from '@vueuse/integrations/useSortable'


export default /*@__PURE__*/_defineComponent({
  __name: 'CollectionListing',
  props: {
  collection: {
    type: Array as PropType<any[]>,
    required: true,
  },
  color: {
    type: String,
    default: null
  },
  favorites: {
    type: Boolean,
    default: false
  },
  reorderable: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {




const profile = useCollectionsStore()

// Set up sorting
const itemsList = ref<HTMLElement | null>(null)
if (__props.reorderable) {
  useSortable(itemsList, __props.collection, {
    draggable: '.reorder-item',
    handle: '.reorder-handle'
  })
}

function handleRemove(item: any) {
  profile.removeSelection(item)
}

function itemAvatar(item: any) {
  // Use the image from the attributes if it exists
  if (item.item_attributes?.image) {
    return item.item_attributes.image
  }

  // Use logos for programs
  if (item.item_type === 'Program') {
    return `/images/logos/programs/${item.item_attributes.slug}.svg`
  }

  // Replace .svg with -b.svg to make blue
  const blueIcon = useIconLib(item.item_type).replace('.svg', '-b.svg')
  return `/images/icons/${blueIcon}`
}

function itemIcon(item: any) {
  return item.deleting ? 'Loading' : 'Clear'
}


return (_ctx: any,_cache: any) => {
  const _component_hy_icon = _resolveComponent("hy-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_hy_button = _resolveComponent("hy-button")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "itemsList",
    ref: itemsList
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.collection, (item) => {
      return (_openBlock(), _createBlock(_component_v_list_item, {
        key: item.id,
        to: __props.favorites ? item.route : undefined,
        disabled: item.deleting,
        "prepend-avatar": itemAvatar(item),
        "base-color": __props.color,
        class: "reorder-item"
      }, _createSlots({
        default: _withCtx(() => [
          _createVNode(_component_v_list_item_title, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name) + " ", 1),
              (!item.valid)
                ? (_openBlock(), _createBlock(_component_hy_icon, {
                    key: 0,
                    name: "Warning",
                    small: "",
                    class: "ml-2"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_v_list_item_subtitle, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.item_type) + " ", 1),
              (!item.valid)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.error), 1))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, [
        (!__props.favorites)
          ? {
              name: "append",
              fn: _withCtx(() => [
                _createVNode(_component_hy_button, {
                  type: "Clear",
                  color: "grey",
                  icon: "",
                  onClick: _withModifiers(($event: any) => (handleRemove(item)), ["stop"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_hy_icon, {
                      name: itemIcon(item)
                    }, null, 8, ["name"])
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                (__props.reorderable)
                  ? (_openBlock(), _createBlock(_component_hy_icon, {
                      key: 0,
                      name: "Reorder",
                      color: "grey",
                      small: "",
                      class: "reorder-handle"
                    }))
                  : _createCommentVNode("", true)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["to", "disabled", "prepend-avatar", "base-color"]))
    }), 128))
  ], 512))
}
}

})